import { Routes } from '@angular/router';
import { routesSysadminDefault } from './routes_sysadmin_default';
import { routesSysadminLocalidades } from './routes_sysadmin_localidades';

export const routesSysadmin: Routes = [
  ...routesSysadminDefault,
  ...routesSysadminLocalidades
];
